<template>
    <transition name="fade" appear>
        <div class="results" :class="'results--'+this.quiz_state.outcome">

            <div class="results__side">
                <img class="results__image" :src=getImgUrl(outcome.image_url)>
            </div>

            <div class="results__main">
                <img src="@/images/cloud-1.svg" class="results__cloud-1">
                <img src="@/images/cloud-2.svg" class="results__cloud-2">

                <div class="results__main-content">
                    <div class="results__top">
                        <img src="@/images/critter-1.svg" class="results__critter-1">
                        <img src="@/images/critter-2.svg" class="results__critter-2">
                        <img src="@/images/critter-3.svg" class="results__critter-3">

                        <h1 class="results__title">
                            <div>You are a</div>

                            <div class="results__highlight outline bigger" v-html="outcome.title+'!'">
                            </div>
                        </h1>

                        <div class="results__intro" v-html="outcome.content"></div>

                        <router-link tag="a" :to="share_link" class="button">SHARE YOUR RESULT!</router-link>
                    </div>


                    <h4 class="yellow uppercase">
                        {{ outcome.inspo_text }}
                    </h4>

                    <div class="inspiration">
                        <a
                            class="inspiration__item"
                            href="https://www.mackies.co.uk/news-and-more/inspiration-gallery/"
                            v-for="(inspiration, index) in outcome.inspiration"
                            :key="index"
                        >
                            <img
                                class="inspiration__image"
                                :src="getImgUrl(inspiration.image)"
                            />
                        </a>
                    </div>

                    <h4 class="yellow uppercase">
                        {{ outcome.others_text }}
                    </h4>

                    <ResultsSummary :quiz_data="quiz_data" />

                    <router-link tag="a" :to="share_link" class="button">SHARE YOUR RESULT!</router-link>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import ResultsSummary from "@/components/ResultsSummary";
export default {
    name: "Results",
    props: {
        quiz_data: Object,
        quiz_state: Object,
    },
    components: {ResultsSummary},
    data() {
        return {
            outcome: null,
            share_link: '/'
        };
    },
    created() {
        this.outcome = this.quiz_data.outcomes[this.quiz_state.outcome];
        this.share_link = "/share/" + this.quiz_state.outcome;

        window.fbq('trackCustom', 'FinishedQuiz');
    },
    methods: {
    }
}
</script>

<style scoped lang="stylus">
.results {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    h4 {
        margin-bottom: 1.5em;
    }

    &__cloud-1 {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        max-width: 30%;
        pointer-events none;
        user-select none;
    }

    &__cloud-2 {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        max-width: 30%;
        pointer-events none;
        user-select none;
    }

    &__top {
        position: relative;
        margin-bottom: 4.5em;
    }

    &__critter-1,
    &__critter-2,
    &__critter-3 {
        position: absolute;
        user-select none;
    }

    &__critter-1 {
        left: calc(50% - 14em);
        top: 15%;
        width: 1.5em;
        display: none;
    }

    &__critter-2 {
        left: -2em;
        bottom: -5em;
        width: 2em;
    }

    &__critter-3 {
        right: -2em;
        bottom: -3em;
        width: 2em;
    }

    &__main {
        background: brand-blue;
        color: white;
        position: relative;
    }

    &__main-content {
        margin: 0 auto;
        padding: calc(6% + 1em);
        box-sizing: border-box;
        width: 100%;
    }

    &__intro {
        max-width: 28em;
        margin: 0 auto;
    }

    &__side {
        background: brand-skyblue;
        color: brand-blue;
    }

    &__image {
        width: 100%;
    }

    &--smooth-operator {
        & ^[0]__side {
            background: #b3e3fa;
        }

        & ^[0]__highlight {
            color: brand-skyblue;
        }
    }

    &--matchmaker {
        & ^[0]__side {
            background: #f2c0d9;
        }

        & ^[0]__highlight {
            color: mix(brand-pink, white, 30);
        }
    }

    &--showstopper {
        & ^[0]__side {
            background: #e46c17;
        }

        & ^[0]__highlight {
            color: #e46c17;
        }
    }

    @media (min-width: 800px) {
        flex-direction: row;

        &__main {
            width: 60%;
        }

        &__side {
            order: 1;
            width: 40%;
        }

        &__image {
            position: sticky;
            top: 119px;
            width: 100%;
        }
    }

    @media (max-width: 470px) {
        &__title {
            font-size: 1.45em;
        }
    }
}

.inspiration {
    display: flex;
    flex-wrap: wrap;
    align-items center;
    justify-content center;
    gap: calc(1.5em / 3) 1.5em;
    margin-bottom: 5em;

    &__item {
        display: block;
        transition: 0.1s ease;
        transition-property: background-color, color, border-color, box-shadow, transform;

        &:hover {
            transform: scale(1.05);
        }
    }

    &__image {
        object-fit: cover;
        width: 10em;
        height: 10em;
        display: block;
        border-radius 50%;
        image-rendering: -webkit-optimize-contrast;
    }
}

</style>